import { getFunctions, httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

// Function to manually recalculate stats
export const recalculateStats = async () => {
  try {
    const recalculateStatsFunction = httpsCallable(functions, 'recalculateStats');
    const result = await recalculateStatsFunction();
    
    return {
      success: true,
      data: result.data
    };
  } catch (error) {
    console.error('Error recalculating stats:', error);
    return {
      success: false,
      error: error.message
    };
  }
};